import { render, staticRenderFns } from "./MortgageRelated.vue?vue&type=template&id=2c98525f"
import script from "./MortgageRelated.vue?vue&type=script&lang=js"
export * from "./MortgageRelated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports